module.exports = __webpack_public_path__ + "img/delivery.992bff50.svg";